import React, {ReactElement} from "react";
import {Button} from "react-bootstrap";
import {v4 as uuidv4} from "uuid";

interface TimeSelectDropDownProps {
    options: string[];
    selectedValue: string;
    handleSelection: (time: string) => void;
    handleToggleOpen: () => void;
    timeToggleOpen: boolean;
}

const CustomSelectDropDown: React.FC<TimeSelectDropDownProps> = ({
                                                                     options,
                                                                     selectedValue,
                                                                     handleSelection,
                                                                     handleToggleOpen,
                                                                     timeToggleOpen,
                                                                 }) => {
    const uniqueId = uuidv4();
    const renderTimeItemElements = () => {
        const items: ReactElement[] = [];
        options?.forEach((s) => {
            items.push(
                <Button
                    className="tertiary-button pickup-button"
                    variant="outline-secondary"
                    onClick={() => {
                        handleSelection(s);
                    }}
                    key={s}
                >
                    {s}
                </Button>,
            );
        });
        return items;
    };

    if (options && options.length >= 1) {
        const menuClass = `dropdown-menu${timeToggleOpen ? " show" : ""} dropDownTimings`;
        const attriId = `pickupTimings${uniqueId}`;
        return (
            <div className="dropdown">
                <Button
                    className="btn tertiary-button btn-secondary dropdown-toggle m-1 pickUpTimeButton"
                    type="button"
                    id={attriId}
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    onClick={handleToggleOpen}
                >
                    {selectedValue && selectedValue?.includes('ASAP') ? (
                        <span className="horizontalAlignCenter">
                            <span>{selectedValue.split(' ')[0]}</span>
                            &nbsp;
                            <span className="font-sub" style={{fontSize: "15px"}}>{selectedValue.split(' ').slice(1).join(' ')}</span>
                        </span>
                    ) : (
                        <span className="">{selectedValue}</span>
                    )}
                </Button>
                <div
                    className={menuClass}
                    aria-labelledby={attriId}
                    style={{textAlign: "center"}}
                >
                    {renderTimeItemElements()}
                </div>
            </div>
        );
    }
    return null;
};

export default CustomSelectDropDown;
